import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as bookActions from '../../../actions/bookActions';
import { TRANSLATE_TAG } from '../../../const';
import { PropTypes } from 'prop-types';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';
import { ANALYTICS_CONTEXT } from '../../../types/analytics';

class RemoveBookReveal extends React.Component {
  static propTypes = {
    bookActions: PropTypes.any,
    bookToRemove: PropTypes.any,
    classroom: PropTypes.any,
    colors: PropTypes.any
  };

  closeModal() {
    const { bookActions } = this.props;
    bookActions.setRemoveBookState(null);
  }

  removeBook() {
    this.closeModal();
    let { bookToRemove, classroom, bookActions } = this.props;
    bookActions.deleteBook(classroom.id, bookToRemove.id, bookToRemove.activityId, ANALYTICS_CONTEXT.BOOK_DELETE);
  }

  render() {
    const { bookToRemove } = this.props;
    let active = false;
    let name = '';

    if (bookToRemove !== null) {
      name = getBookName(bookToRemove);
      active = true;
    }
    let confirmDelete = I18n.t('bookContainer.confirmDelete').replace(`${TRANSLATE_TAG.TITLE}`, name);

    return (
      <Modal
        id="remove-book"
        title={I18n.t('bookContainer.deleteBook')}
        active={active}
        onClickOutside={this.closeModal.bind(this)}
        children={
          <Paragraph className="text-grey-700">
            {confirmDelete} {I18n.t('common.uSure')}
          </Paragraph>
        }
        footer={
          <>
            <Button onClick={this.closeModal.bind(this)} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.removeBook.bind(this)} primary label={I18n.t('common.delete')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function getBookName(book) {
  let finalName = '';
  if (book.name) {
    let name = JSON.parse(book.name);
    let locale = Object.keys(name);
    finalName = `'${name[locale[0]]}'`;
  }
  return finalName;
}

function mapStateToProps(state) {
  return {
    bookToRemove: state.book.bookToRemove,
    i18n: state.i18n,
    colors: state.theme.colors,
    classroom: state.classrooms.selectedClassroom.classroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveBookReveal);
